<block-ui>
  <!-- Subheader -->
  <!-- Page Content -->
  <div [ngStyle]="{'display': ShowPageContent==true?'block':'none'}" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="PermissionSetForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="PermissionSetForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->

          <button type="button" class="btn btn-sm btn-primary" title="Add" (click)="showAddPermissionSetModal(AddPermissionSetModal)">
            <i class="fas fa-plus me-1"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>

          <!-- end::Menu -->
        </div>
      </div>
      <div class="card-body py-3">
        <div class="table-responsive">
          <!--begin::Permission list-->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
                <th class="min-w-150px" *ngIf="!ProductionMode">{{utilityService.getResourceValue("SysName")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("UsersCount")}}</th>
                <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

              <tr *ngFor="let PermissionSet of PermissionSetPagingResult">

                <td>
                  <a href="javascript:void(0)" *ngIf="language=='en'" (click)="SaveName(PermissionSet.name)" [routerLink]="['/Admin/Roles/PermissionSetInfo',PermissionSet.id]" routerLinkActive="router-link-active"
                     class="text-dark">{{PermissionSet.name.english}}</a>

                  <a href="javascript:void(0)" *ngIf="language=='ar'" (click)="SaveName(PermissionSet.name)" [routerLink]="['/Admin/Roles/PermissionSetInfo',PermissionSet.id]" routerLinkActive="router-link-active"
                     class="text-dark">{{PermissionSet.name.arabic}}</a>

                </td>
                <td *ngIf="!ProductionMode">{{PermissionSet.sysName}}</td>
                <td>{{PermissionSet.usersCount}}</td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <a class="drop-item px-3" ngbDropdownItem
                         (click)="showEditPermissionSetModal(PermissionSet,EditPermissionSetModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                      </a>
                      <a ngbDropdownItem class="drop-item px-3"
                         (click)="showDeletePermissionSetModal(PermissionSet,deletePermissionSetModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                      </a>
                    </mat-menu>
                  </div>
                </td>
              </tr>
              <tr *ngIf="PermissionSetPagingResult.length == 0">
                <td [attr.colspan]="ProductionMode ? '3' : '4'">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>
          <!--end::Permission list-->
        </div>

      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setPermissionSetListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="PermissionSetPaging" [group]="PermissionSetForm" #PermissionSetPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>

  </div>


  <!-- Add Modal -->
  <ng-template #AddPermissionSetModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("AddPermissionSet")}}</h1>
      </div>
      <form [formGroup]="AddPermissionSetForm" (ngSubmit)="addPermissionSet()">
        <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="AddPermissionSetForm"></BBSF-MultiLingualTextBox>
        <BBSF-TextBox [options]="ActiveDirectoryGroup" [group]="AddPermissionSetForm">
        </BBSF-TextBox>
        <BBSF-TextBox *ngIf="!ProductionMode" [options]="SysName" [group]="AddPermissionSetForm">
        </BBSF-TextBox>
        <BBSF-DropdownList [options]="Permissions" [group]="AddPermissionSetForm">
        </BBSF-DropdownList>
        <BBSF-DropdownList [options]="Organization" [group]="AddPermissionSetForm">
        </BBSF-DropdownList>
        <div class="text-center pt-7">
          <button type="button" #ClosePermissionSetModal id="ClosePermissionSetModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>



  <!-- Edit Modal -->
  <ng-template #EditPermissionSetModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("EditPermissionSet")}}</h1>
      </div>
      <form [formGroup]="EditPermissionSetForm" (ngSubmit)="editPermissionSet()">
        <BBSF-MultiLingualTextBox [options]="EditMultiLingualName" [group]="EditPermissionSetForm"></BBSF-MultiLingualTextBox>
        <BBSF-TextBox [options]="EditActiveDirectoryGroup" [group]="EditPermissionSetForm">
        </BBSF-TextBox>
        <div *ngIf="!ProductionMode">
          <BBSF-TextBox [options]="EditSysName" [group]="EditPermissionSetForm">
          </BBSF-TextBox>
        </div>
        <BBSF-DropdownList [options]="EditPermissions" [group]="EditPermissionSetForm">
        </BBSF-DropdownList>
        <BBSF-DropdownList [options]="EditOrganization" [group]="EditPermissionSetForm">
        </BBSF-DropdownList>
        <div class="text-center pt-7">
          <button type="button" #CloseEditPermissionSetModal id="CloseEditPermissionSetModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>



  <!-- Delete  Modal -->
  <ng-template #deletePermissionSetModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("PermissionSet")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeletePermissionSetModal id="CloseDeletePermissionSetModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="deletePermissionSet()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>


